// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {
  padding: 32px;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {
  padding: 14px 20px;
  align-items: center;
  justify-content: flex-end;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {
  width: 50px;
  max-height: 28px;
  min-height: unset;
  padding: 10px 6px;
  border-radius: 8px;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {
  font-size: 12px;
  font-weight: 500;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {
  display: none;
}

.BC-Onboarding-Plan-Modal h1 {
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  margin-bottom: 8px;
  line-height: 36px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {
  text-align: center;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {
  max-width: 1172px;
  margin: auto;
  margin-top: 24px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {
  font-size: 12px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,
.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .BC-Page__SubscriptionV3.V4
  .price
  > .price-number {
  font-size: 36px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {
  background-color: #f6f6f7;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button {
  background-color: transparent;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button__Text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button
  .Polaris-Icon {
  margin: 0;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare.btn-compare--expand
  .Polaris-Icon {
  transform: rotate(180deg);
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {
  margin-bottom: 48px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {
  width: 100%;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 8px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {
  text-align: center;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .column-package--success
  .Polaris-Button {
  background: #008060;
  border-color: #008060;
  color: #ffffff;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {
  overflow: auto;
  max-height: 500px;
}

.BC-Onboarding-Plan-Modal .btn-to-top {
  position: fixed;
  bottom: 80px;
  right: 28px;
  z-index: 99;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #007f5f;
  cursor: pointer;
  transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {
  width: 18px;
  height: 18px;
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {
  fill: #007f5f;
}

.BC-Onboarding-Plan-Modal .btn-to-top:hover {
  background-color: #fff;
}
.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content {
  padding: 40px;
}

.BC-Onboarding-PlanV5-Modal h1 {
  margin-bottom: 12px;
}

.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .Polaris-Card {
  max-width: 936px;
  margin: auto;
  margin-top: 32px;
}

.BC-Onboarding-PlanV5-Modal .BC-SubscriptionV5_ExplorePackages .packages {
  margin-top: unset !important;
}

.BC-Onboarding-PlanV5-Modal .BC-Page__Package-ComparisonV5 {
  max-width: 1172px;
  margin: auto;
  height: auto;
  margin-top: 60px;
}

.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {
    max-height: unset;
}`, "",{"version":3,"sources":["webpack://./src/styles/onboarding-plan.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {\n  padding: 32px;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {\n  padding: 14px 20px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {\n  width: 50px;\n  max-height: 28px;\n  min-height: unset;\n  padding: 10px 6px;\n  border-radius: 8px;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {\n  display: none;\n}\n\n.BC-Onboarding-Plan-Modal h1 {\n  font-weight: 700;\n  font-size: 28px;\n  text-align: center;\n  margin-bottom: 8px;\n  line-height: 36px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {\n  text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {\n  max-width: 1172px;\n  margin: auto;\n  margin-top: 24px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {\n  font-size: 12px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .BC-Page__SubscriptionV3.V4\n  .price\n  > .price-number {\n  font-size: 36px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {\n  background-color: #f6f6f7;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button {\n  background-color: transparent;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button__Text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare.btn-compare--expand\n  .Polaris-Icon {\n  transform: rotate(180deg);\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {\n  margin-bottom: 48px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {\n  width: 100%;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 36px;\n  margin-bottom: 8px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {\n  text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .column-package--success\n  .Polaris-Button {\n  background: #008060;\n  border-color: #008060;\n  color: #ffffff;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {\n  overflow: auto;\n  max-height: 500px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top {\n  position: fixed;\n  bottom: 80px;\n  right: 28px;\n  z-index: 99;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #007f5f;\n  cursor: pointer;\n  transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {\n  width: 18px;\n  height: 18px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #007f5f;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top:hover {\n  background-color: #fff;\n}\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content {\n  padding: 40px;\n}\n\n.BC-Onboarding-PlanV5-Modal h1 {\n  margin-bottom: 12px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .Polaris-Card {\n  max-width: 936px;\n  margin: auto;\n  margin-top: 32px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-SubscriptionV5_ExplorePackages .packages {\n  margin-top: unset !important;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Page__Package-ComparisonV5 {\n  max-width: 1172px;\n  margin: auto;\n  height: auto;\n  margin-top: 60px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {\n    max-height: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
